import * as types from '../mutation-types'
import api from '../../api'
import localStorageService from '../../utils/local-storage-service'
import router from '@/router'

var menuAdapter = {
  menus: [],
  init (data) {
    var self = this
    self.menus = []
    data.forEach((item, index, array) => {
      var path = self.getModulePath(item.menus)
      self.menus.push({
        name: item.name,
        path: path,
        id: self.setModuleId(item.id),
        icon: item.icon,
        menus: item.menus,
        children: self.initChildren(0, item.menus)
      })
    })
    return self.menus
  },
  initChildren (parentid, data) {
    var self = this
    var menus = []
    data.forEach((item, index, array) => {
      if (item.parentid === parentid) {
        menus.push({
          name: item.name,
          path: item.path,
          id: item.id,
          parentid: item.parentid,
          moduleid: self.setModuleId(item.moduleid),
          children: self.initChildren(item.id, data),
          deep: item.deep
        })
      }
    })
    return menus
  },
  setModuleId (id) {
    return 'module_' + id
  },
  getModulePath (array) {
    if (array === undefined || array.length === 0) {
      return ''
    }
    return array[0].path
  }
}

const localStorageKey = {
  globalConfig: 'globalConfig'
}

const state = {
  currentMenus: null,
  activeModule: {},
  activeMenu: {},
  currentPath: '',
  permissions: [],
  menuAuth: false,
  get configs () {
    let configs = localStorageService.getItem(localStorageKey.globalConfig)
    return configs || {}
  }
}

const actions = {
  GetUserMenus ({ commit }) {
    return api.auth.getMenus()
    .then(rs => {
      commit(types.CurrentMenuSet, rs)
    },
    reject => {
    })
  },
  ReactivateModule ({ dispatch, commit, state }, path) {
    state.currentPath = path
    if (!state.currentMenus) {
      dispatch('GetUserMenus')
      .then(() => {
        commit(types.ActiveMoudleChange)
        dispatch('GetMenuPermissions')
      })
    } else {
      commit(types.ActiveMoudleChange)
      dispatch('GetMenuPermissions')
    }
  },
  GetMenuPermissions ({ dispatch, commit, state }) {
    api.auth.getMenuPermissions(state.activeMenu.id)
      .then(rs => {
        commit(types.GetMenuPermissions, rs)
      })
  },
  ClearUserSetting ({ commit }) {
    commit(types.CurrentSettingClear)
  },
  GetConfigs ({ commit }) {
    var configs = api.auth.getConfigs()
    commit(types.CurrentConfigsSet, configs)
  }
}

const mutations = {
  [types.CurrentMenuSet] (state, menus) {
    let allMenu = menuAdapter.init(menus)
    state.currentMenus = allMenu
  },

  [types.CurrentSettingClear] (state) {
    state.currentMenus = null
    state.activeModule = {}
    state.activeMenu = {}
    state.currentPath = ''
  },

  [types.ActiveMoudleChange] (state) {
    let currentModule = {}
    let path = state.currentPath
    let has = false
    if (state.currentMenus) {
      state.currentMenus.forEach((module, index, array) => {
        var currentMenu = module.menus.filter((menu, index, array) => {
          return (path + '/').indexOf(menu.path + '/') > -1
        })
        if (currentMenu && currentMenu.length > 0 && !has) {
          state.activeMenu = currentMenu[0]
          currentModule = module
          has = true
        }
      })
    }
    state.menuAuth = has
    state.activeModule = currentModule
    if (!has && path !== '/') {
      router.push('/401')
    }
  },

  [types.GetMenuPermissions] (state, permissions) {
    state.permissions = permissions
  },

  [types.CurrentConfigsSet] (state, configs) {
    localStorageService.setItem(localStorageKey.globalConfig, configs)
    state.configs = configs
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/current-setting.js